import { StudentProgress } from '../../../pages/reports/StudentProgress/StudentProgress';
import { ExperienceSummary } from '../../../pages/reports/ExperienceSummary/ExperienceSummary';

interface ReportPickerComponentProps {
  reportType: string | null;
  onInited?: (value?: boolean) => void;
}

export const ReportPickerComponent = ({
  reportType,
  onInited,
}: ReportPickerComponentProps) => {
  if (reportType === 'student-progress') {
    return <StudentProgress onInited={onInited} />;
  }
  if (reportType === 'experience-summary') {
    return <ExperienceSummary onInited={onInited} />;
  }

  /*    
  } else if (reportType === 'student-summary') {
    return <StudentSummary onInited={onInited} />;
  } else if (reportType === 'district-curriculum-progress') {
    return <DistrictCurriculumProgress onInited={onInited} />;
  } else if (reportType === 'school-curriculum-progress') {
    return <SchoolCurriculumProgress onInited={onInited} />;
  } else if (reportType === 'school-teks-summary') {
    return <SchoolTeksSummary onInited={onInited} />;
  } else if (reportType === 'school-teks-summary-no-type') {
    return <SchoolTeksSummaryNoType onInited={onInited} />;
  } else if (reportType === 'school-district-teks-summary') {
    return <SchoolDistrictTeksSummary onInited={onInited} />;
  } else if (reportType === 'school-district-teks-summary-no-type') {
    return <SchoolDistrictTeksSummaryNoType onInited={onInited} />;
  } else if (reportType === 'school-district-teks-summary-no-type') {
    return <SchoolDistrictTeksSummaryNoType onInited={onInited} />;
  } else if (reportType === 'school-district-teks-summary-no-type') {
    return <SchoolDistrictTeksSummaryNoType onInited={onInited} />;
  } else if (reportType === 'school-district-teks-summary-no-type') {
    return <SchoolDistrictTeksSummaryNoType onInited={onInited} />;
  } else if (reportType === 'school-district-teks-summary-no-type') { 
  */
  return null;
};

export default ReportPickerComponent;
